

import { useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

export default function ResultPage() {
  const location = useLocation();
  const navigate = useNavigate();

  const [paid, setPaid] = useState(false);
  const [animatedScore, setAnimatedScore] = useState(0);
  const [selectedMatch, setSelectedMatch] = useState(null);


  // const score = location.state?.score || 0;
  const score =
  location.state?.score ||
  parseInt(localStorage.getItem("love_score")) ||
  0;


  // 分数动画
  useEffect(() => {
    let current = 0;
    const interval = setInterval(() => {
      current += 1;
      if (current > score) {
        clearInterval(interval);
        current = score;
      }
      setAnimatedScore(current);
    }, 20);
    return () => clearInterval(interval);
  }, [score]);

  // 分数分析
  let type = "", summary = "", full = "";
  if (score >= 18) {
    type = "理想稳定型 ❤️";
    summary = "你在关系中非常成熟，适合长期稳定婚姻。";
    full =
      "你具备优秀的沟通能力和责任感，在关系中更注重信任与长期发展。适合你的对象类型：温柔型、支持型伴侣。";
  } else if (score >= 14) {
    type = "成长平衡型 🌱";
    summary = "你具备良好的关系基础，但仍有提升空间。";
    full =
      "你在情感与理性之间较为平衡，但在冲突处理和安全感方面仍需提升。适合你的对象类型：成熟型、引导型伴侣。";
  } else {
    type = "情感探索型 🔍";
    summary = "你仍在探索适合自己的关系模式。";
    full =
      "你在关系中可能存在情绪波动或方向不清的问题，需要更多自我认知与成长。适合你的对象类型：包容型、耐心型伴侣。";
  }

  // 模拟匹配用户

  const matches = [
  {
    name: "小红",
    desc: "温柔体贴",
    age: 26,
    city: "上海",
    matchRate: "92%",
    tags: ["善解人意", "情绪稳定"],
    img: "/avatar1.png",
  },
  {
    name: "小明",
    desc: "幽默风趣",
    age: 28,
    city: "北京",
    matchRate: "88%",
    tags: ["幽默", "外向"],
    img: "/avatar2.png",
  },
  {
    name: "小丽",
    desc: "独立自主",
    age: 25,
    city: "杭州",
    matchRate: "90%",
    tags: ["独立", "理性"],
    img: "/avatar3.png",
  },
  {
    name: "小刚",
    desc: "成熟稳重",
    age: 30,
    city: "深圳",
    matchRate: "85%",
    tags: ["可靠", "事业型"],
    img: "/avatar4.png",
  },
];


  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 to-purple-50 flex flex-col justify-center items-center p-6">

      <h2 className="text-3xl font-bold mb-6 text-center">你的婚恋分析报告</h2>

      {/* 分数卡 */}
      <div className="max-w-xl w-full bg-white p-6 rounded-2xl shadow mb-6 text-center">
        <p className="text-lg mb-2">综合评分</p>
        <p className="text-4xl font-bold text-pink-500 mb-2">{animatedScore}</p>
        <p className="text-xl font-bold text-pink-600 mb-2">{type}</p>
        <p className="text-gray-600">{summary}</p>
      </div>

      {/* 付费解锁报告 */}
      <div className="max-w-xl w-full bg-white p-6 rounded-2xl shadow mb-6 text-center">
        {!paid ? (
          <>
            <div className="blur-sm text-gray-400 mb-4 leading-relaxed">{full}</div>
            <p className="text-sm text-gray-500 mb-4">
              🔒 解锁完整报告，查看你的婚恋优势 / 风险 / 专属建议
            </p>
            <button
              onClick={() => setPaid(true)}
              className="bg-pink-500 text-white px-8 py-3 rounded-full hover:bg-pink-600 transition transform active:scale-95"
            >
              解锁完整报告 ¥19.9
            </button>
          </>
        ) : (
          <div className="text-left text-gray-700 leading-relaxed animate-fadeIn">
            <h3 className="font-bold mb-2">详细分析：</h3>
            <p>{full}</p>
            <div className="mt-4">
              <h4 className="font-semibold">✔ 建议提升：</h4>
              <ul className="list-disc ml-5 text-sm mt-2">
                <li>增强沟通能力</li>
                <li>提升情绪稳定性</li>
                <li>明确关系目标</li>
              </ul>
            </div>
          </div>
        )}
      </div>

      {/* 匹配推荐 */}

      <div className="max-w-xl w-full mb-6">
  <h3 className="font-semibold mb-3 text-left">推荐匹配</h3>

  <div className="grid grid-cols-4 gap-4">
    {matches.map((m, i) => (
      <div
        key={i}
        onClick={() => setSelectedMatch(m)}
        className="bg-pink-50 p-3 rounded-xl shadow text-center cursor-pointer
        transform transition duration-200 hover:scale-105 active:scale-95"
      >
        <img
          src={m.img}
          className="w-16 h-16 mx-auto rounded-full mb-2"
        />
        <p className="font-semibold">{m.name}</p>
        <p className="text-xs text-gray-500">{m.desc}</p>


      </div>
    ))}
  </div>
</div>


      {/* 下一步按钮 */}
       <div className="flex flex-col items-center gap-3">

  <button
    onClick={() => navigate("/discover")}
    className="bg-pink-500 text-white px-6 py-3 rounded-full"
  >
    ❤️ 去找对象
  </button>

  <button
    onClick={() => navigate("/chat-list")}
    className="text-pink-600 underline"
  >
    我的消息 →
  </button>

  <button
    onClick={() => navigate("center/profile")}
    className="text-gray-500 underline"
  >
    完善资料 →
  </button>

</div>





      <style>{`
  .animate-fadeIn {
    animation: fadeIn 0.3s ease;
  }

  @keyframes fadeIn {
    from { opacity: 0; transform: scale(0.9); }
    to { opacity: 1; transform: scale(1); }
  }
`}</style>


      {selectedMatch && (
  <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">

    <div className="bg-white w-80 rounded-2xl p-6 relative animate-fadeIn">

      {/* 关闭按钮 */}
      <button
        onClick={() => setSelectedMatch(null)}
        className="absolute top-3 right-3 text-gray-400"
      >
        ✕
      </button>

      {/* 头像 */}
      <img
        src={selectedMatch.img}
        className="w-20 h-20 mx-auto rounded-full mb-3"
      />

      {/* 基本信息 */}
      <h3 className="text-xl font-bold text-center">
        {selectedMatch.name}
      </h3>

      <p className="text-center text-gray-500 text-sm mb-2">
        {selectedMatch.age}岁 · {selectedMatch.city}
      </p>

      {/* 匹配度 */}
      <p className="text-center text-pink-500 font-bold mb-3">
        匹配度 {selectedMatch.matchRate}
      </p>

      {/* 标签 */}
      <div className="flex flex-wrap gap-2 justify-center mb-4">
        {selectedMatch.tags.map((tag, i) => (
          <span
            key={i}
            className="text-xs bg-pink-100 text-pink-600 px-2 py-1 rounded-full"
          >
            {tag}
          </span>
        ))}
      </div>

      {/* 描述 */}
      <p className="text-sm text-gray-600 text-center mb-4">
        {selectedMatch.desc}
      </p>

      {/* 按钮 */}
      <div className="flex gap-3">
     <button
  onClick={() =>
    navigate("/chat", {
      state: { user: selectedMatch },
    })
  }
  className="flex-1 bg-pink-500 text-white py-2 rounded-lg"
>
  💬 聊天
</button>






        <button
          onClick={() => alert("已收藏")}
          className="flex-1 border border-pink-500 text-pink-500 py-2 rounded-lg"
        >
          ❤️ 收藏
        </button>
      </div>

    </div>
  </div>
)}

    </div>


  );
}
